import { DeliveryMetrics } from "../../common/common.types"
import { useEffect, useMemo, useState } from 'react'
import { apiFetchBody } from '../../utility/fetch'
import { useLoading } from '../../loading/LoadingContext'

export interface UseAmazonFedExDeliveryMetricsGetContext {
  fedexDeliveryMetricsGetError: any | undefined
  deliveryMetrics: DeliveryMetrics[]
}

const useAmazonFedExDeliveryMetricsGet = (startDate, endDate, userData, triggerRefresh): UseAmazonFedExDeliveryMetricsGetContext => {
  const {toggleLoading, changeStep, changeSubStep} = useLoading()
  const [currentData, setCurrentData] = useState([])
  const [currentError, setCurrentError] = useState(undefined)

  useEffect(() => {
    const load = async function(){
      try {
        changeStep('Getting Amazon Fedex Delivery Metrics')
        changeSubStep(`Between Start Date ${startDate} and End Date ${endDate}`)
        toggleLoading(true)

        const responseData = await apiFetchBody<DeliveryMetrics[]>({
          endpoint: 'amazonFedExDeliveryMetrics',
          method: 'GET',
          params: [{key: 'startDate', value: `${startDate}`}, {key: 'endDate', value: `${endDate}`}],
          accessToken: userData.accessToken
        })
        setCurrentData(responseData)
      }catch(error){
        setCurrentError(error)
        console.error(error)
      }finally {
        toggleLoading(false)
      }
    }
    load()
  }, [startDate, endDate, userData, triggerRefresh])

  const context: UseAmazonFedExDeliveryMetricsGetContext = useMemo(() => {
    return {
      deliveryMetrics: currentData,
      fedexDeliveryMetricsGetError: currentError
    }
  }, [currentError, currentData])

  return context
}

export default useAmazonFedExDeliveryMetricsGet